import {mapGetters} from 'vuex';
import Header from '@/components/component/Header/Header.vue'
import Footer from '@/components/component/Footer/Footer.vue'
import { getUserProfile, organisationWithoutCollab, getUserPermissions } from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import {errorHandler, message, logout} from '@/libs/helper'
import settings from '@/libs/constant/settings'

export default {
    name: 'app',
    data() {
        return {
            isInfo: false
        }
    },
    async created() {
        /* || this.$route.path.includes('/iam_user/') || this.$route.path.includes('/iam_user_group/') || this.$route.path.includes('/iam_create_group/') */
        if(this.$route.path.includes('/ip/') || this.$route.path.includes('/dp/') || this.$route.path.includes('/short-url/') || this.$route.path.includes('/locations/') || this.$route.path.includes('/iam-dashboard/') || this.$route.path.includes('/publisher-api/')) {
            this.isInfo = true
        }
        else this.isInfo = false
        await this.fetchOrganisationWithCollabList()
        this.fetchUserProfile()
    },
    watch: {
        '$route' (to) {
            if (to.path.includes('/ip/') || to.path.includes('/dp/') || to.path.includes('/short-url/') || to.path.includes('/locations/') || to.path.includes('/iam-dashboard/') || to.path.includes('/publisher-api/')) {
                this.isInfo = true 
            } 
            else 
                this.isInfo = false
        },
        refreshOrganisationList (newValue) {
            if (newValue) {
                this.$store.dispatch('setRefreshOrganisationList', false)
                this.fetchOrganisationWithCollabList()
            }
        },
        refreshUserProfileAndPermissions (newValue) {
            if(newValue){
                this.$store.dispatch('setRefreshUserProfileAndPermissions', false)
                this.fetchUserProfile()
            }
        }
    },
    computed: {
        ...mapGetters({
            userInformation: constants.getters.GET_USER_INFORMATION,
            organisationWithoutCollaborator: constants.getters.GET_ORGANSIATION_WITHOUT_COLLABORATOR,
            selectedAccount: constants.getters.GET_SELECTED_ACCOUNT,
            refreshOrganisationList: 'getRefreshOrganisationList',
            refreshUserProfileAndPermissions: 'getRefreshUserProfileAndPermissions'

        })
    },
    components: {
        Header,
        Footer
    },
    methods: {
        fetchOrganisationWithCollabList () {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // api call to get the profile
            organisationWithoutCollab()
            .then(response => {
                this.$store.dispatch('setOrganisationsWithoutCollaborator', response)
                if (response.length > 0) {
                    // main account info of user
                    let mainAccountInfo = response[0]
                    // set user info in store
                    this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, mainAccountInfo);
                    // check if the current account is admin account
                    if(mainAccountInfo.is_admin) localStorage.setItem('accura_ad', constants.ROLE.ADMIN)
                    // set language in locale
                    this.$i18n.locale = mainAccountInfo.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB;
                    // persist language in local staorage
                    localStorage.setItem('lang', mainAccountInfo.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB)
                    loading.close();
                }
            }).catch(error => {
                console.log('error', error)
                loading.close();
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        fetchUserProfile() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            getUserProfile({})
                .then((response)=> {
                    if (response && response.id) {  
                        // this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                        // if(response.is_admin) localStorage.setItem('accura_ad', constants.ROLE.ADMIN)
                        // this.$i18n.locale = response.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB;
                        // localStorage.setItem('lang', response.language || settings.LOCIZE.LANGUAGE.ENGLISH_GB)
                    }
                    // set active profile in local storage
                    if (response && (response.id || response._id)) {
                        localStorage.setItem('activeProfile', response.id || response._id)
                        this.$store.dispatch('setSelectedAccount', response || {})
                        localStorage.setItem(`profile_${response.id || response._id}`, localStorage.getItem('accuraAuthToken'))
                    }
                    if ( response.type === 'ORGANISATION' ) {
                        this.fetchUserPermissions()
                    } else this.$store.dispatch('clearSitePermissions')
                    loading.close();
                    })
                .catch((error)=> {
                    console.log('error', error)
                    loading.close();
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        },
        fetchUserPermissions() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
                getUserPermissions()
                .then((response) => {
                    const permissions = response.permissions.map((item) => {
                        return item.permissionSlugName
                    })
                    this.$store.dispatch('setSitePermissions', permissions)
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                })
        }
    }
}

